import { ZodFormattedError, z } from 'zod';

export const clientSchema = z
  .object({
    REACT_APP_BASE_API_URL: z.string().optional(),
    REACT_APP_API_HOSTS: z.string().optional(),
    REACT_APP_APP_BASE_URL: z.string().nonempty(),
    REACT_APP_DEPLOYMENT_ENV: z.string().nonempty(),
    REACT_APP_REDIRECT_SUCCESS: z.string().nonempty(),
    REACT_APP_REDIRECT_FAILURE: z.string().nonempty(),
    REACT_APP_REDIRECT_CANCEL: z.string().nonempty(),
    REACT_APP_SENTRY_DSN: z.string().nonempty(),
    REACT_APP_FIREBASE_API_KEY: z.string().nonempty(),
    REACT_APP_FIREBASE_AUTH_DOMAIN: z.string().nonempty(),
    REACT_APP_FIREBASE_PROJECT_ID: z.string().nonempty(),
    REACT_APP_FIREBASE_STORAGE_BUCKET: z.string().nonempty(),
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: z.string().nonempty(),
    REACT_APP_FIREBASE_APP_ID: z.string().nonempty(),
    REACT_APP_SWITCH_TRADING_URL: z.string().nonempty(),
  })
  .refine((data) => data.REACT_APP_API_HOSTS || data.REACT_APP_BASE_API_URL, {
    message: `Either REACT_APP_API_HOSTS or REACT_APP_BASE_API_URL must be set.
REACT_APP_API_HOSTS: JSON mapping of hostname to API URL, e.g. '{"10.0.4.16":"http://10.0.4.16:8081/api/1/"}'
REACT_APP_BASE_API_URL: Single API URL fallback, e.g. 'http://10.0.4.16:8081/api/1/'`,
  });

const _clientEnv = clientSchema.safeParse(process.env);

export const formatErrors = (
  errors: ZodFormattedError<Map<string, string>, string>
) => {
  const messages: string[] = [];

  if (errors._errors?.length) {
    messages.push(...errors._errors);
  }

  for (const [name, value] of Object.entries(errors)) {
    if (name === '_errors') continue;
    if (value && typeof value === 'object' && '_errors' in value) {
      const fieldErrors = (value as { _errors: string[] })._errors;
      if (fieldErrors?.length) {
        messages.push(`${name}: ${fieldErrors.join(', ')}`);
      }
    }
  }

  return messages;
};

if (_clientEnv.success === false) {
  const errorMessages = formatErrors(_clientEnv.error.format());
  const errorText = errorMessages.join('\n');
  console.error(`❌ Invalid environment variables:\n${errorText}`);
  throw new Error(`Invalid environment variables:\n${errorText}`);
}

export const env = _clientEnv.data;
